import {
  getOptions,
  mqttApiVersionItems,
  mqttServerTypeItems
} from '@/shared/SelectData'
import { Guid } from '@/utils/guid'
import { getFormatMessage } from '@/utils/utils'
import { Button, Divider, Form, Input, Select } from 'antd'
import React, { useEffect } from 'react'
import { ServerItem, ServerProps } from './interface'

export const Server: React.FC<ServerProps> = (props: ServerProps) => {
  const [form] = Form.useForm()
  const formatMessage = getFormatMessage()

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 10 }
    }
  }

  const tailLayout = {
    wrapperCol: { offset: 4, span: 10 }
  }

  const handleSubmit = (values: any) => {
    const merged: ServerItem = Object.assign(props.item, values)
    if (!merged.id) {
      merged.id = Guid.raw()
    }
    merged.name = 'EMQX服务器'
    if (props.onFormSubmitted) {
      props.onFormSubmitted(merged)
    }
  }

  useEffect(() => {
    form.setFieldsValue(props?.item)
  }, [props.item])

  return (
    <div>
      <Form {...formItemLayout} form={form} onFinish={handleSubmit}>
        <Form.Item
          label={formatMessage({ id: 'app.server.edit.type' })}
          name='type'
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'app.server.edit.type.message' })
            }
          ]}
        >
          <Select>{getOptions(mqttServerTypeItems)}</Select>
        </Form.Item>

        <Divider orientation='left' />

        <Form.Item
          label={formatMessage({ id: 'app.server.edit.apiUrl' })}
          name={['config', 'apiUrl']}
          rules={[
            {
              required: true,
              transform: (value) => value?.trim(),
              message: formatMessage({ id: 'app.server.edit.apiUrl.message' })
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={formatMessage({ id: 'app.server.edit.apiVersion' })}
          name={['config', 'apiVersion']}
          rules={[
            {
              required: true,
              message: formatMessage({
                id: 'app.server.edit.apiVersion.message'
              })
            }
          ]}
        >
          <Select>{getOptions(mqttApiVersionItems)}</Select>
        </Form.Item>

        <Form.Item
          label={formatMessage({ id: 'app.server.edit.appId' })}
          name={['config', 'appId']}
          rules={[
            {
              required: true,
              transform: (value) => value?.trim(),
              message: formatMessage({
                id: 'app.server.edit.appId.message'
              })
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={formatMessage({ id: 'app.server.edit.appSecret' })}
          name={['config', 'appSecret']}
          rules={[
            {
              required: true,
              transform: (value) => value?.trim(),
              message: formatMessage({
                id: 'app.server.edit.appSecret.message'
              })
            }
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label={formatMessage({ id: 'app.server.edit.mqttAddress' })}
          name={['config', 'mqttAddress']}
          rules={[
            {
              required: true,
              transform: (value) => value?.trim(),
              message: formatMessage({
                id: 'app.server.edit.mqttAddress.message'
              })
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item {...tailLayout} style={{ textAlign: 'right' }}>
          <Button htmlType='submit' type='primary'>
            {formatMessage({ id: 'app.server.edit.save' })}
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}
